module.exports = __webpack_public_path__ + "static/media/ic_EU.3b927c0b.svg";